// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const FIN_ST_TAX_CONVERCAO = {
  Definitiva: 'FIN_ST_TAX_CONVERCAO1',
  ProvisoriaDataReferenciaIndisponivel: 'FIN_ST_TAX_CONVERCAO2',
  ProvisoriaTaxaDefinitivaIndisponivel: 'FIN_ST_TAX_CONVERCAO3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    FIN_ST_TAX_CONVERCAO1: 1,
    FIN_ST_TAX_CONVERCAO2: 2,
    FIN_ST_TAX_CONVERCAO3: 3
  }
}
